import { ITypedReduxAction } from '../../types/redux/actionType';
import { TRequestCallbackOpener } from '../../types/requestCallback';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ERequestCallbackActionTypes {
  OpenPopup = 'requestCallback/openPopup',
  ClosePopup = 'requestCallback/closePopup',
}

export type TOpenRequestCallbackPopup = ITypedReduxAction<
  ERequestCallbackActionTypes.OpenPopup,
  TRequestCallbackOpener
>;
export type TCloseRequestCallbackPopup = ITypedReduxAction<ERequestCallbackActionTypes.ClosePopup, void>;

export const openRequestCallbackPopup = actionGenerator<ERequestCallbackActionTypes.OpenPopup, TRequestCallbackOpener>(
  ERequestCallbackActionTypes.OpenPopup,
);
export const closeRequestCallbackPopup = actionGenerator<ERequestCallbackActionTypes.ClosePopup>(
  ERequestCallbackActionTypes.ClosePopup,
);

export type TRequestCallbackActions = TOpenRequestCallbackPopup | TCloseRequestCallbackPopup;
